/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Spaces_Gallery_ConnectInputs */



/**
* | output |
* | --- |
* | "Connect {name}" |
*
* @param {Spaces_Gallery_ConnectInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_gallery_connect = /** @type {((inputs: Spaces_Gallery_ConnectInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Gallery_ConnectInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.name} verbinden`)
	return /** @type {LocalizedString} */ (`Connect ${i?.name}`)
});